export const initialFirmwareState = {
    channelsByProjectIdByDeviceClassId: {},
    channelIdsByProjectId: {},
    bundlesByProjectIdByDeviceClassId: {},
    bundleIdsByProjectId: {},
};
